import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Input,
  Radio,
  Form,
  Modal,
  DatePicker,
  Button,
} from "antd";
import { Spin } from "antd";

import Evaluation from "./Evaluation";
import { exportPacePdf } from "./ExportEvaluationPdf";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import dayjs from "dayjs";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Select } from "antd";
import isoWeek from "dayjs/plugin/isoWeek";
import useToken from "../Authentication/useToken";
import Constants from "../Utils/Constants";

dayjs.extend(isoWeek);

const API_BASE_URL = Constants.SERVER_URL;
// Fonction d'export PDF modifiée qui gère correctement le token
const handleExportPacePdf = async (payload, token) => {
  if (!payload || !token) {
    console.error("Données manquantes pour l'exportation PDF");
    Modal.error({
      title: i18next.t("title_error"),
      content: i18next.t("error_missing_data_for_pdf_export"),
    });
    return;
  }

  try {
    await exportPacePdf(payload, token);
  } catch (error) {
    console.error("Erreur lors de l'exportation PDF PACE:", error);
    if (error.response) {
      console.error(
        "Réponse du serveur:",
        error.response.status,
        error.response.data
      );
    }
    Modal.error({
      title: i18next.t("error_pdf_export"),
      content: i18next.t("error_pdf_export_connexion"),
    });
  }
};

//pour les rappels d'evaluation 
const getReminderDates = (startDate, durationWeeks) => {
  const reminders = [];

  const reminderWeeks = {
    8: [8],
    12: [12],
    16: [8, 16],
    24: [12, 24],
  };

  const weeks = reminderWeeks[durationWeeks] || [];

  weeks.forEach((week) => {
    let date = dayjs(startDate).add(week, 'week');
    const day = date.day();

    // Si samedi ou dimanche, pousser au lundi suivant
    if (day === 0) date = date.add(1, 'day');
    else if (day === 6) date = date.add(2, 'day');

    // 👉 convertir en format ISO attendu par Sequelize/PostgreSQL
    reminders.push(date.toISOString());
  });

  return reminders;
};


function EvaluationPACE() {
  const { t } = useTranslation("Evaluations");
  const { patientId  } = useParams(); // récupère l'ID depuis l'URL
  console.log(" Paramètre URL (id) :", patientId ); // <--- AJOUT ICI

  const { token } = useToken(); // récupération du token d'auth

  //  Fonction définie proprement en dehors du useState
  const getInitialFormData = () => {
    const parsedId = parseInt(patientId, 10);
 
    
    
    return {
      idPatient: isNaN(parsedId) ? null : parsedId,
      chairTestSupport: true,
      chairTestCount: "",
      chairTestTime: "",
      balanceFeetTogether: "",
      balanceSemiTandem: "",
      balanceTandem: "",
      balanceOneFooted: "",
      
      frtPosition: true,
      frtDistance: "",
      canWalk: undefined,
      walkingTime: "",
      walkingAid: "",
      //programModality:"",
      supportFootUnipodal: "",         // ✅ pour balanceOneFooted
      supportFootSemiTandem: "",       // ✅ pour balanceSemiTandem
      supportFootTandem: "",  
    };
  };

  

  const [formData, setFormData] = useState(() => getInitialFormData());
  const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
  const [programStartDate, setProgramStartDate] = useState(null);
  const [programDurationWeeks, setProgramDurationWeeks] = useState(12);
  const [useCustomDuration, setUseCustomDuration] = useState(false);
  const [customDuration, setCustomDuration] = useState("");
  const [frequencyType, setFrequencyType] = useState("auto");
  const [customDays, setCustomDays] = useState([]);

  const [evaluationId, setEvaluationId] = useState(null);
  const [programModality, setProgramModality] = useState("Présentiel");
  const [evaluationDuration, setEvaluationDuration] = useState("");
  const [submittedWalkingTime, setSubmittedWalkingTime] = useState(null);

  const [teachingOnEvaluationDay, setTeachingOnEvaluationDay] = useState(true);
const [teachingDate, setTeachingDate] = useState(null);


  
  
  
/** 
  const generateCalendarEvents = () => {
    console.log("ID Patient:", formData.idPatient);
    console.log("Start Date:", programStartDate?.toISOString());
    console.log("Custom Days:", customDays);
    console.log(" formData:", formData);


    const startDate = programStartDate;
    const weeks = useCustomDuration ? customDuration : programDurationWeeks;
  
    if (!startDate || !weeks || !formData?.idPatient) {
      console.log("Données manquantes :", { startDate, weeks, patientId: formData?.idPatient });
      return [];
    }
    
  
    const sessions = [];
    const start = dayjs(startDate);
    const end = start.add(Number(weeks), "week");
    let current = start.clone();
  
    while (current.isBefore(end)) {
      const day = current.day();
  
      const isSessionDay =
        frequencyType === "auto"
          ? true
          : customDays.includes(Object.keys(dayMap).find(key => dayMap[key] === day));
  
      if (isSessionDay) {
        const startStr = current.hour(14).minute(0).format();
        const endStr = current.hour(15).minute(0).format();
  
        sessions.push({
          name: "Séance PACE",
          startDate: startStr,
          endDate: endStr,
          patientId: formData.idPatient,
          programId: null, // À compléter plus tard si nécessaire
        });
      }
  
      current = current.add(1, "day");
    }
  
    return sessions;
  
  
  };**/
 const handleProgramPlanning = async () => {
  try {
    const payload = {
      evaluationId: evaluationId,
      programStartDate: programStartDate?.toISOString(),
      programDurationWeeks: useCustomDuration ? customDuration : programDurationWeeks,
      frequencyType,
      customDays,
      nextEvaluationDates: getReminderDates(
        programStartDate,
        useCustomDuration ? customDuration : programDurationWeeks
      ),
      modality: programModality, 
      evaluationDuration: evaluationDuration,
      teachingOnEvaluationDay,
  teachingDate: teachingOnEvaluationDay ? null : teachingDate?.toISOString()

    };

    //  Enregistre uniquement la planification
    await axios.post(`${Constants.SERVER_URL}/program-plannings`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });



    Modal.success({
      title: "Planification enregistrée",
      content: "La planification du programme a été enregistrée avec succès.",
    });

    // ✅ Rafraîchir les données affichées
    setIsScheduleModalVisible(false);
  } catch (error) {
    console.error("Erreur lors de la planification :", error);
    Modal.error({
      title: "Erreur",
      content: "Échec de l'enregistrement de la planification.",
    });
  }
};


  const calculateScores = (formData) => {
    const scoreA = calculateChairTestScore(formData);
    const scoreB = calculateBalanceScore(formData);
    const scoreC = calculateMobilityScore(formData);
    const totalScore = scoreA + scoreB + scoreC;
    const level = determineLevel(totalScore);
    const color = determineColor(scoreA, scoreB, scoreC);
    const frenchColor = determineFrenchColor(scoreA, scoreB, scoreC);

    return {
      cardioMusculaire: scoreA,
      equilibre: scoreB,
      mobilite: scoreC,
      total: totalScore,
      level,
      color,
      frenchColor,
      program: frenchColor + " " + level,
    };
  };

  const calculateChairTestScore = (formData) => {
    const count = parseInt(formData.chairTestCount);
    const withSupport = formData.chairTestSupport;

    if (count === 0) return 0;
    if (withSupport && count >= 10) return 2;
    if (withSupport && count >= 1) return 1;
    if (!withSupport && count >= 16) return 6;
    if (!withSupport && count >= 13) return 5;
    if (!withSupport && count >= 10) return 4;
    if (!withSupport && count >= 5) return 3;
    if (!withSupport && count >= 1) return 2;
    return 0;
  };

  const calculateBalanceScore = (formData) => {
    const feetTogether = parseFloat(formData.balanceFeetTogether || 0);
    const semiTandem = parseFloat(formData.balanceSemiTandem || 0);
    const tandem = parseFloat(formData.balanceTandem || 0);
    const oneFooted = parseFloat(formData.balanceOneFooted || 0);

    if (oneFooted >= 10) return 6;
    if (oneFooted >= 5) return 5;
    if (tandem >= 10) return 4;
    if (tandem >= 5) return 3;
    if (semiTandem >= 10) return 2;
    if (feetTogether >= 10) return 1;
    return 0;
  };

  const calculateMobilityScore = (formData) => {
    if (formData.frtPosition === "armNotWorking") return 0;

    const distance = parseFloat(formData.frtDistance);
    const isStanding = !formData.frtPosition; // false signifie debout
    const balanceScore = calculateBalanceScore(formData);

    // Position debout (si B ≥ 5 OU Assis = 40 cm)
    if (isStanding) {
      if (distance > 35) return 6;
      if (distance >= 27) return 5;
      if (distance >= 15) return 4;
      if (distance > 0) return 3;
      return 0;
    } else {
      // Position assise
      if (distance > 35) return 4;
      if (distance >= 27) return 3;
      if (distance >= 15) return 2;
      if (distance < 15 && distance > 0) return 1;
      return 0;
    }
  };

  const determineLevel = (totalScore) => {
    if (totalScore >= 16) return "V";
    if (totalScore >= 13) return "IV";
    if (totalScore >= 9) return "III";
    if (totalScore >= 5) return "II";
    return "I";
  };

  const determineColor = (scoreA, scoreB, scoreC) => {
    const min = Math.min(scoreA, scoreB, scoreC);

    // Si tous les scores sont égaux
    if (scoreA === scoreB && scoreB === scoreC) return t("color_brown");

    // Si deux scores sont égaux et minimum
    if (scoreA === scoreB && scoreA === min) return t("color_green");
    if (scoreB === scoreC && scoreB === min) return t("color_orange");
    if (scoreC === scoreA && scoreC === min) return t("color_purple");

    // Si un seul score est minimum
    if (scoreA === min) return t("color_blue");
    if (scoreB === min) return t("color_yellow");
    if (scoreC === min) return t("color_red");

    return t("color_brown"); // Cas par défaut
  };

  // Pour que le programme envoyé à la BD soit en français
  const determineFrenchColor = (scoreA, scoreB, scoreC) => {
    const min = Math.min(scoreA, scoreB, scoreC);
    if (scoreA === scoreB && scoreB === scoreC) return "MARRON";
    if (scoreA === scoreB && scoreA === min) return "VERT";
    if (scoreB === scoreC && scoreB === min) return "ORANGE";
    if (scoreC === scoreA && scoreC === min) return "VIOLET";
    if (scoreA === min) return "BLEU";
    if (scoreB === min) return "JAUNE";
    if (scoreC === min) return "ROUGE";
    return "MARRON";
  };

  const calculateSpeed = (walkingTime) => {
    const time = parseFloat(walkingTime);
    if (isNaN(time) || time <= 0) return "0.00";
    return (4 / time).toFixed(2);
  };

  const calculateWalkingObjective = (walkingTime) => {
    const time = parseFloat(walkingTime);

    if (isNaN(time) || time < 0 || walkingTime === "") {
      return null;
    }

    if (time === 0) {
      return 10;
    }

    const speed = 4 / time;

    if (speed < 0.4) return 10;
    if (speed >= 0.4 && speed < 0.6) return 15;
    if (speed >= 0.6 && speed < 0.8) return 20;
    if (speed >= 0.8) return 30;

    return null;
  };
  const buildPayload = (
  formData,
  scores,
  patientId,
  isBalanceTestEnabled,
  extra = {}
) => {
  return {
    idPatient: patientId,
    chairTestSupport: formData.chairTestSupport ? "with" : "without",
    chairTestCount: formData.chairTestCount?.toString() ?? "",
    chairTestTime: formData.chairTestTime?.toString() ?? "",
    balanceFeetTogether: formData.balanceFeetTogether?.toString() ?? "0",
    
    balanceSemiTandem: isBalanceTestEnabled("balanceSemiTandem")
      ? formData.balanceSemiTandem?.toString() ?? "0"
      : "0",
    balanceTandem: isBalanceTestEnabled("balanceTandem")
      ? formData.balanceTandem?.toString() ?? "0"
      : "0",
    balanceOneFooted: isBalanceTestEnabled("balanceOneFooted")
      ? formData.balanceOneFooted?.toString() ?? "0"
      : "0",
    frtSitting:
      formData.frtPosition === true
        ? "sitting"
        : formData.frtPosition === false
        ? "standing"
        : "not_working",
    frtDistance:
      formData.frtPosition === "armNotWorking"
        ? "0"
        : formData.frtDistance?.toString() ?? "0",
    walkingTime: formData.canWalk
      ? formData.walkingTime?.toString() ?? "0"
      : "0",
    walkingAid: formData.walkingAid || "none",
    canWalk: !!formData.canWalk,
    programStartDate: extra.programStartDate
      ? dayjs(extra.programStartDate).format("YYYY-MM-DD")
      : null,
    programDurationWeeks: extra.programDurationWeeks?.toString() ?? "0",
    frequencyType: extra.frequencyType,
    modality: extra.programModality ?? "",
    customDays:
      extra.frequencyType === "custom" ? extra.customDays ?? [] : [],
    nextEvaluationDates: extra.nextEvaluationDates ?? [],
    scores: {
      cardioMusculaire: scores.cardioMusculaire,
      equilibre: scores.equilibre,
      mobilite: scores.mobilite,
      total: scores.total,
      program: scores.program,
    },
    supportFootUnipodal: formData.supportFootUnipodal ?? "",
    supportFootSemiTandem: formData.supportFootSemiTandem ?? "",
    supportFootTandem: formData.supportFootTandem ?? "",
    
  };
};


  const buildModalContent = (scores,formData) => {
    
    return (
      <div className="results-container">
        <h3
          style={{
            marginBottom: "20px",
            borderBottom: "1px solid #eee",
            paddingBottom: "10px",
          }}
        >
          {t("title_results_eval_pace")}
        </h3>

        <div style={{ marginBottom: "15px" }}>
          <strong>{t("individual_scores")}</strong>
          <p>
            {t("text_cardio_score")} : {scores.cardioMusculaire}/6
          </p>
          <p>
            {t("text_balance_score")} : {scores.equilibre}/6
          </p>
          <p>
            {t("text_mobility_score")}: {scores.mobilite}/6
          </p>
        </div>

        <div style={{ marginBottom: "15px" }}>
          <strong>
            {t("text_total_score")} : {scores.total}/18
          </strong>
        </div>

        <div
          style={{
            marginTop: "20px",
            backgroundColor: "#f5f5f5",
            padding: "15px",
            borderRadius: "5px",
          }}
        >
          <p>
            <strong>
              {t("text_level")} : {scores.level}
            </strong>
          </p>
          <p>
            <strong>
              {t("text_recommended_program")} : {scores.color} {scores.level}
            </strong>
          </p>
        </div>

        {/* si canWalk === true ET walkingTime, on affiche la vitesse */}
        {formData.canWalk && formData.walkingTime && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              {t("text_walk_speed")} : {calculateSpeed(formData.walkingTime)}{" "}
              {t("text_speed_unit")}
            </p>
            <p>
              {formData.canWalk && formData.walkingTime && calculateWalkingObjective(formData.walkingTime) !== null && (
  <p>
    <strong>
      {t("title_walk_objective")} :{" "}
      {calculateWalkingObjective(formData.walkingTime)} {t("text_minutes_per_day")}
    </strong>
  </p>
)}

            </p>
          </div>
        )}

        {/* Sinon, s'il ne peut pas marcher */}
        {!formData.canWalk && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              <strong>{t("title_walking_ability_to_work")}</strong>
            </p>
          </div>
        )}
        
    




      </div>
    );
  };


  
  // Fonction personnalisée de validation pour corriger le problème lié à la marche
  const validateForm = (formData, errors) => {
    const newErrors = { ...errors };

    // Validation qui ne rejettera pas la soumission si le patient ne peut pas marcher
    if (formData.canWalk === false) {
      // Si le patient ne peut pas marcher, on supprime l'erreur liée au temps de marche
      delete newErrors.walkingTime;
    } else if (formData.canWalk === true) {
      // Si le patient peut marcher, on vérifie que le temps est bien renseigné
      if (!formData.walkingTime) {
        newErrors.walkingTime = t("error_walk_time_required");
      } else if (
        isNaN(formData.walkingTime) ||
        parseFloat(formData.walkingTime) < 0
      ) {
        newErrors.walkingTime = t("error_walk_time_invalid");
      }
    }

    return newErrors;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const renderFormFields = (
    formData,
    handleChange,
    errors,
    isBalanceTestEnabled
  ) => {
    return (
      <>
        {/* Section A: CARDIO-MUSCULAIRE (inchangée) */}
        <h2>{t("title_sectionA")}</h2>
        <Form.Item label={t("label_chair_test")}>
          <Radio.Group
            name="chairTestSupport"
            value={formData.chairTestSupport}
            onChange={(e) =>
              handleChange({
                target: { name: "chairTestSupport", value: e.target.value },
              })
            }
          >
            <Radio value={true}>{t("radio_with_support")}</Radio>
            <Radio value={false}>{t("radio_without_support")}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={t("label_stand_count")}
          validateStatus={errors.chairTestCount ? "error" : ""}
          help={errors.chairTestCount}
        >
          <Input
            name="chairTestCount"
            value={formData.chairTestCount}
            onChange={handleChange}
            placeholder={t("placeholder_stand_count")}
          />
        </Form.Item>
        <Form.Item
          label={t("label_temp_pour_5_répétition")}
          validateStatus={errors.chairTestTime ? "error" : ""}
          help={errors.chairTestTime}
        >
  <Input
    name="chairTestTime"
    value={formData.chairTestTime}
    onChange={handleChange}
    placeholder="Ex: 30"   // Juste un placeholder, simple
  />
</Form.Item>

       {/* Section B: ÉQUILIBRE (corrigée avec un seul <Row>) */}
<h2>{t("title_sectionB")}</h2>
<div style={{ marginBottom: 16 }}>{t("text_balance_instructions")}</div>

<Row gutter={16}>
  {/* Pieds joints */}
  <Col span={12}>
    <Form.Item
      label={
        <span style={{ display: "flex", alignItems: "center" }}>
          {t("label_feet_together")}
          <img
            src={require("./images/pace_balance_joint.png")}
            alt="Joint Feet"
            style={{ marginLeft: 8, height: 24 }}
          />
        </span>
      }
      validateStatus={errors.balanceFeetTogether ? "error" : ""}
      help={errors.balanceFeetTogether}
    >
      <Input
        className="half-width-input"
        name="balanceFeetTogether"
        value={formData.balanceFeetTogether}
        onChange={handleChange}
        placeholder={t("placeholder_time")}
        disabled={!isBalanceTestEnabled("balanceFeetTogether")}
      />
    </Form.Item>
  </Col>

  {/* Pieds semi tandem */}
  <Col span={12}>
    <Form.Item
      label={
        <span style={{ display: "flex", alignItems: "center" }}>
          {t("label_feet_semi_tandem")}
          <img
            src={require("./images/pace_balance_semi_tandem.png")}
            alt="Semi tandem Feet"
            style={{ marginLeft: 8, height: 24 }}
          />
        </span>
      }
      validateStatus={errors.balanceSemiTandem ? "error" : ""}
      help={errors.balanceSemiTandem}
    >
      <Input
        className="half-width-input"
        name="balanceSemiTandem"
        value={formData.balanceSemiTandem}
        onChange={handleChange}
        placeholder={t("placeholder_time")}
        disabled={!isBalanceTestEnabled("balanceSemiTandem")}
      />
    </Form.Item>

    {formData.balanceSemiTandem && (
      <Form.Item
        label="Quel pied est devant ?"
        validateStatus={errors.supportFootSemiTandem ? "error" : ""}
        help={errors.supportFootSemiTandem}
      >
        <Radio.Group
          name="supportFootSemiTandem"
          value={formData.supportFootSemiTandem}
          onChange={(e) =>
            handleChange({
              target: {
                name: "supportFootSemiTandem",
                value: e.target.value,
              },
            })
          }
        >
          <Radio value="gauche">Gauche</Radio>
          <Radio value="droit">Droit</Radio>
        </Radio.Group>
      </Form.Item>
    )}
  </Col>

  {/* Pieds tandem */}
  <Col span={12}>
    <Form.Item
      label={
        <span style={{ display: "flex", alignItems: "center" }}>
          {t("label_feet_tandem")}
          <img
            src={require("./images/pace_balance_tandem.png")}
            alt="Tandem Feet"
            style={{ marginLeft: 8, height: 24 }}
          />
        </span>
      }
      validateStatus={errors.balanceTandem ? "error" : ""}
      help={errors.balanceTandem}
    >
      <Input
        name="balanceTandem"
        className="half-width-input"
        value={formData.balanceTandem}
        onChange={handleChange}
        placeholder={t("placeholder_time")}
        disabled={!isBalanceTestEnabled("balanceTandem")}
      />
    </Form.Item>

    {formData.balanceTandem && (
      <Form.Item
        label="Quel pied est devant ?"
        validateStatus={errors.supportFootTandem ? "error" : ""}
        help={errors.supportFootTandem}
      >
        <Radio.Group
          name="supportFootTandem"
          value={formData.supportFootTandem}
          onChange={(e) =>
            handleChange({
              target: {
                name: "supportFootTandem",
                value: e.target.value,
              },
            })
          }
        >
          <Radio value="gauche">Gauche</Radio>
          <Radio value="droit">Droit</Radio>
        </Radio.Group>
      </Form.Item>
    )}
  </Col>

  {/* Pied unipodal */}
  <Col span={12}>
    <Form.Item
      label={
        <span style={{ display: "flex", alignItems: "center" }}>
          {t("label_feet_unipodal")}
          <img
            src={require("./images/pace_balance_unipodal.png")}
            alt="Unipodal Foot"
            style={{ marginLeft: 8, height: 24 }}
          />
        </span>
      }
      validateStatus={errors.balanceOneFooted ? "error" : ""}
      help={errors.balanceOneFooted}
    >
      <Input
        name="balanceOneFooted"
        className="half-width-input"
        value={formData.balanceOneFooted}
        onChange={handleChange}
        placeholder={t("placeholder_time")}
        disabled={!isBalanceTestEnabled("balanceOneFooted")}
      />
    </Form.Item>

    {formData.balanceOneFooted && (
      <Form.Item
        label="Quel pied est au sol ?"
        validateStatus={errors.supportFootUnipodal ? "error" : ""}
        help={errors.supportFootUnipodal}
      >
        <Radio.Group
          name="supportFootUnipodal"
          value={formData.supportFootUnipodal}
          onChange={(e) =>
            handleChange({
              target: {
                name: "supportFootUnipodal",
                value: e.target.value,
              },
            })
          }
        >
          <Radio value="gauche">Gauche</Radio>
          <Radio value="droit">Droit</Radio>
        </Radio.Group>
      </Form.Item>
    )}
  </Col>
</Row>




        {/* Section C: MOBILITÉ & STABILITÉ DU TRONC (inchangée) */}
        <h2>{t("title_sectionC")}</h2>
        <Form.Item label={t("label_functional_reach_test")}>
          <Radio.Group
            name="frtPosition"
            value={formData.frtPosition}
            onChange={(e) =>
              handleChange({
                target: { name: "frtPosition", value: e.target.value },
              })
            }
          >
            <Radio value={true}>{t("radio_sitting")}</Radio>
            <Radio value={false}>{t("radio_standing")}</Radio>
            <Radio value="armNotWorking">{t("radio_arms_not_working")}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={t("label_distance")}
          validateStatus={errors.frtDistance ? "error" : ""}
          help={errors.frtDistance}
        >
          <Input
            name="frtDistance"
            value={formData.frtDistance}
            onChange={handleChange}
            placeholder={t("placeholder_distance")}
            disabled={formData.frtPosition === "armNotWorking"}
          />
        </Form.Item>

        {/* SECTION D : OBJECTIF DE MARCHE  */}
        <h2>{t("title_sectionD")}</h2>
        <Form.Item label={t("label_walk_test")}>
          <Radio.Group
            value={formData.canWalk}
            onChange={(e) =>
              handleChange({
                target: { name: "canWalk", value: e.target.value },
              })
            }
            style={{ marginBottom: "16px" }}
          >
            <Radio value={true}>{t("radio_patient_can_walk")}</Radio>
            <Radio value={false}>{t("radio_patient_cannot_walk")}</Radio>
          </Radio.Group>

          {formData.canWalk && (
            <Form.Item
              label={t("label_time_needed_walk_4m")}
              validateStatus={errors.walkingTime ? "error" : ""}
              help={errors.walkingTime}
            >
              <Input
                name="walkingTime"
                value={formData.walkingTime}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d*\.?\d*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                placeholder={t("walktime_placeholder")}
              />
              {formData.walkingTime && !errors.walkingTime && (
                <div style={{ marginTop: 8, color: "#666" }}>
                  {t("text_walk_speed")} :{" "}
                  {calculateSpeed(formData.walkingTime)} {t("text_speed_unit")}
                  <div style={{ marginTop: 4 }}>
                    <strong>
                      {t("title_walk_objective")} :{" "}
                      {calculateWalkingObjective(formData.walkingTime)}{" "}
                      {t("text_minutes_per_day")}
                    </strong>
                  </div>
                </div>
              )}
            </Form.Item>
          )}
        </Form.Item>
        {formData.canWalk && (
  <Form.Item label="Type d'aide technique utilisée">
    <Radio.Group
      name="walkingAid"
      value={formData.walkingAid}
      onChange={(e) =>
        handleChange({
          target: { name: "walkingAid", value: e.target.value },
        })
      }
    >
      <Radio value="aucune">Aucune aide technique</Radio>
      <Radio value="canne">Canne</Radio>
      <Radio value="marchette">Marchette</Radio>
      <Radio value="deambulateur">Déambulateur</Radio>
      <Radio value="autre">Autre</Radio>
    </Radio.Group>
  </Form.Item>
)}


<Modal
  title={t("title_program_schedule")}
  open={isScheduleModalVisible}
  onCancel={() => setIsScheduleModalVisible(false)}
  footer={null}
  destroyOnClose={true}
> 

  <p>
    <strong>{t("text_program_title")}:</strong>{" "}
    {programStartDate
      ? dayjs(programStartDate).format("DD/MM/YYYY")
      : t("text_no_date_selected")}
  </p>
      <Form.Item label="Enseignement du programme">
  <Radio.Group
    onChange={(e) => setTeachingOnEvaluationDay(e.target.value)}
    value={teachingOnEvaluationDay}
  >
    <Radio value={true}>Le jour de l’évaluation</Radio>
    <Radio value={false}>À une autre date</Radio>
  </Radio.Group>
</Form.Item>

{!teachingOnEvaluationDay && (
  <Form.Item label="Date d’enseignement">
    <DatePicker
      value={teachingDate}
      onChange={(date) => setTeachingDate(date)}
    />
  </Form.Item>
)}

  <Form.Item label={t("label_program_start_date")}>
    <DatePicker
      value={programStartDate}
      onChange={(date) => setProgramStartDate(date)}
    />
  </Form.Item>

  <Form.Item label={t("label_program_duration_proposed")}>
    <Input value={`${programDurationWeeks} ${t("text_weeks")}`} disabled />
  </Form.Item>

  <Form.Item>
    <Radio.Group
      onChange={(e) => setUseCustomDuration(e.target.value)}
      value={useCustomDuration}
    >
      <Radio value={false}>Utiliser la durée proposée</Radio>
      <Radio value={true}>Spécifier une durée personnalisée</Radio>
    </Radio.Group>
  </Form.Item>

  {useCustomDuration && (
    <Form.Item label="Durée personnalisée (en semaines)">
    <Select
      value={customDuration}
      onChange={(value) => setCustomDuration(value)}
      placeholder="Choisir une durée"
    >
      <Select.Option value={8}>8 semaines</Select.Option>
      <Select.Option value={16}>16 semaines</Select.Option>
      <Select.Option value={24}>24 semaines</Select.Option>
    </Select>
  </Form.Item>
  
  )}

  <Form.Item label={t("label_program_end_date")}>
    <Input
      value={
        programStartDate
          ? dayjs(programStartDate)
              .add(Number(useCustomDuration ? customDuration : programDurationWeeks), "week")
              .format("DD/MM/YYYY")
          : t("text_no_date_selected")
      }
      disabled
    />
  </Form.Item>
  <Form.Item label="Date(s) de la prochaine évaluation">
  <ul>
    {programStartDate &&
      getReminderDates(
        programStartDate,
        Number(useCustomDuration ? customDuration : programDurationWeeks)
      ).map((reminder, index) => (
        <li key={index}>
          {new Date(reminder).toLocaleDateString("fr-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
        </li>

      ))}
  </ul>
</Form.Item>


  <Form.Item label="Fréquence des séances">
    <Radio.Group
      onChange={(e) => setFrequencyType(e.target.value)}
      value={frequencyType}
    >
      <Radio value="auto">Fréquence proposée (1x/jour)</Radio>
      <Radio value="custom">Fréquence libre</Radio>
    </Radio.Group>
  </Form.Item>

  {frequencyType === "custom" && (
    <Form.Item label="Jours de séances par semaine">
      <Select
        mode="multiple"
        value={customDays}
        onChange={setCustomDays}
      >
        <Select.Option value="monday">Lundi</Select.Option>
        <Select.Option value="tuesday">Mardi</Select.Option>
        <Select.Option value="wednesday">Mercredi</Select.Option>
        <Select.Option value="thursday">Jeudi</Select.Option>
        <Select.Option value="friday">Vendredi</Select.Option>
      </Select>
    </Form.Item>
    
  )}
  <Form.Item
  label="Modalité d’évaluation"
  name="modality"
  rules={[{ required: true, message: "Veuillez choisir une modalité" }]}
>
  <Select
    placeholder="Choisir la modalité"
    onChange={(value) => setProgramModality(value)}
    value={programModality}
  >
    <Select.Option value="Présentiel">Présentiel</Select.Option>
    <Select.Option value="Virtuel">Virtuel</Select.Option>
    <Select.Option value="À domicile">À domicile</Select.Option>
  </Select>
</Form.Item>



  <Button
  type="primary"
  onClick={handleProgramPlanning}
  disabled={!evaluationId || !programStartDate}
>
  Planifier
</Button>

</Modal>

      </>
    );
  };
  const handleCustomConfirm = () => {
  if (!evaluationId) {
    Modal.warning({
      title: "Évaluation en cours d'enregistrement",
      content: "Veuillez patienter quelques secondes que l'évaluation soit bien enregistrée avant de planifier.",
    });
    return;
  }

  setProgramDurationWeeks(12);
  setIsScheduleModalVisible(true);
};

useEffect(() => {
  console.log(" Nouvelle évaluation enregistrée avec ID :", evaluationId);
}, [evaluationId]);
 


  return (
    <Evaluation
      evaluationType="PACE"
      getInitialFormData={getInitialFormData} // ✅ AJOUT ICI

      calculateScores={calculateScores}
      renderFormFields={renderFormFields}
      buildPayload={(formData, scores, patientId, isBalanceTestEnabled) =>
      buildPayload(formData, scores, patientId, isBalanceTestEnabled, {
        programStartDate,
        programDurationWeeks: useCustomDuration ? customDuration : programDurationWeeks,
        frequencyType,
        customDays,
        programModality
      })
    }

      buildModalContent={(scores, currentFormData) => buildModalContent(scores, currentFormData)}

      validateForm={validateForm}
      exportPdf={handleExportPacePdf}
      idPatient={parseInt(patientId, 10)} 
      onCustomConfirm={handleCustomConfirm} // ✅ Ici c'est ta propre fonction
      onEvaluationCreated={setEvaluationId} // ✅ ici tu dis à Evaluation.jsx quoi faire avec l'ID

    />
  );
  

}

export default EvaluationPACE;
